export function demandRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_DEMAND_START":           
        case "FETCH_DEMANDS_START":                                 
        case "UPDATE_DEMAND_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_DEMAND_FULFILLED":           
        case "FETCH_DEMANDS_FULFILLED":                                 
        case "UPDATE_DEMAND_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_DEMAND_ERROR":
        case "FETCH_DEMANDS_ERROR":
        case "UPDATE_DEMAND_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}